// src/components/ui/PlanLimitBadge.jsx
import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { useAuth } from "../../contexts/AuthContext";

export default function PlanLimitBadge({ tipo }) {
  const { isSuperAdmin } = useAuth();
  const [limites, setLimites] = useState(null);

  useEffect(() => {
    if (isSuperAdmin) return;
    api("GET", "/tenant/limites")
      .then(r => setLimites(r.data))
      .catch(() => {});
  }, [isSuperAdmin]);

  if (isSuperAdmin || !limites || limites.semLimite) return null;

  const info = tipo === "condominios" ? limites.condominios : limites.usuarios;
  if (!info || !info.max) return null; // ilimitado

  const pct = info.pct || 0;
  const cor = pct >= 100 ? "#991B1B" : pct >= 80 ? "#854D0E" : "#166534";
  const bg  = pct >= 100 ? "#FEE2E2" : pct >= 80 ? "#FEF9C3" : "#DCFCE7";
  const label = tipo === "condominios" ? "Condomínios" : "Usuários";

  return (
    <span style={{
      fontSize:12, fontWeight:700, padding:"4px 12px", borderRadius:20,
      background:bg, color:cor, display:"inline-flex", alignItems:"center", gap:6
    }}>
      <i className={`bi bi-${pct>=100?"x-circle":pct>=80?"exclamation-triangle":"check-circle"}`}/>
      {label}: {info.atual}/{info.max}
      {pct>=80 && <span style={{fontSize:10}}>({pct>=100?"Limite atingido":"Quase no limite"})</span>}
    </span>
  );
}
